import {
  Alert,
  CardActions,
  CardHeader,
  Divider,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import { CalendarMonthOutlined } from "@mui/icons-material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import EducationForm from "./forms/EducationForm";
import { CVService } from "../../../../service/CVService";
import { useQuery } from "../../../../hooks/useQuery";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";

const Etudes = () => {
  const [etudes, setEtudes] = useState([]);
  const [currentEtude, setCurrentEtudes] = useState(null);
  const [educationFormDialogOpen, setEducationFormDialogOpen] = useState(false);
  const query = useQuery();
  const id_identite = query.get("id_identite");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { Toast, showToast } = useToast();

  const handleCloseEducationForn = () => {
    setEducationFormDialogOpen(false);
    handleFetchEtudesList({
      id_identite: id_identite,
    });
  };

  const confirmDelete = (education) => {
    CVService.deleteEducation(education.id_etude).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchEtudesList({
          id_identite: id_identite,
        });
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleOpenEducationFormDialog = (education) => {
    setCurrentEtudes(education);
    setEducationFormDialogOpen(true);
  };

  const handleEditEducationFormDialog = (education) => {
    setCurrentEtudes(education);
    setEducationFormDialogOpen(true);
  };

  const handleDeleteEducationFormDialog = (education) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(education)
    );
  };

  const handleFetchEtudesList = (filtre) => {
    CVService.getEducationList(filtre).then((res) => {
      if (res && res.data) {
        setEtudes(res.data);
      }
    });
  };

  useEffect(() => {
    handleFetchEtudesList({
      id_identite: id_identite,
    });
  }, []);

  return (
    <>
      <Toast />
      <DialogComponent />
      <Paper>
        <EducationForm
          open={educationFormDialogOpen}
          onFormClose={handleCloseEducationForn}
          id_education={currentEtude ? currentEtude.id_etude : null}
        />
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Etuducations"
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  onClick={handleOpenEducationFormDialog}
                  text={"Ajouter"}
                  variant={"outlined"}
                />
              </Grid>
            }
          />
          {etudes.length > 0 ? (
            etudes.map((etude, index) => (
              <Grid key={index}>
                <ul>
                  <CardHeader
                    title={
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <li style={{ fontSize: "20px" }}>
                          {`${etude.diplome} | ${etude.filiere}`}
                        </li>
                      </Stack>
                    }
                    subheader={
                      <Grid>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <CalendarMonthOutlined />
                          <span>{`Année : ${etude.annee || ""}`}</span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <BusinessIcon />
                          <span>
                            <span>{`Etablissement : ${etude.etablissement || ""}`}</span>
                          </span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <AccountTreeOutlinedIcon />
                          <span>
                            {" "}
                            {`Parcours : ${etude.description || ""}`}
                          </span>
                        </Stack>
                      </Grid>
                    }
                  />
                  <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                    <AppButton
                      icon={<EditOutlined />}
                      onClick={(e) => handleEditEducationFormDialog(etude)}
                      text={"Modifier"}
                      variant={"outlined"}
                    />
                    <AppButton
                      icon={<DeleteOutline />}
                      onClick={(e) => handleDeleteEducationFormDialog(etude)}
                      text={"Supprimer"}
                      color={"warning"}
                      variant={"outlined"}
                    />
                  </CardActions>
                </ul>
                <Divider variant="middle" />
              </Grid>
            ))
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                {" "}
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default Etudes;
